export var componentsLocales = {
  placeholder: 'Nothing selected'
};